import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { defineStore } from 'pinia';

import { useApi } from '@/composables/useApi';

export default defineStore('agent/vendors', () => {
	const VueRoute = useRoute();

	const vendors = ref(null);
	const isLoading = ref(false);

	async function get(agentId = VueRoute.params.agentID) {
		isLoading.value = true;

		const result = await useApi(`api/agents/${agentId}/vendors/`, {
			message: 'There was an issue retrieving vendor details. Please try again later.',
		}).json();

		isLoading.value = false;
		vendors.value = result.data?.value;
		return result.data?.value;
	}

	async function ensureVendors() {
		if (!vendors.value) {
			await get();
		}
	}

	async function updatePermissions(newPermissions) {
		isLoading.value = true;

		try {
			await useApi(`api/agents/${VueRoute.params.agentID}/vendors/permissions/`, {
				headers: { 'content-type': 'application/json' },
				message:
					'There was an issue with updating vendor permissions. Please try again later.',
			}).put(JSON.stringify(newPermissions));
			await get();
		} catch (error) {
			console.error(error);
			throw error;
		} finally {
			isLoading.value = false;
		}
	}

	return {
		vendors,
		isLoading,

		get,
		ensureVendors,
		updatePermissions,
	};
});
